var React = require('react');

function IcDownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-7276-456v-1.264h24V-456Zm2.653-12.758.884-.884,7.832,7.832V-480h1.264v18.191l7.832-7.832.884.884L-7264-459.41Z","transform":"translate(7276 480.001)","fill":"#0056b4"}));
}

IcDownloadInline.defaultProps = {"width":"24","height":"24.001","viewBox":"0 0 24 24.001"};

module.exports = IcDownloadInline;

IcDownloadInline.default = IcDownloadInline;
